// extracted by mini-css-extract-plugin
module.exports = {"container":"JA","productName":"KA","modal":"LA","dimensions":"MA","recipientEmail":"NA","lowStock":"OA","recommendedFit":"PA","notRecommendedFit":"QA"};